<template>
    <div>
        <!-- Histórico Pacotes -->
        <div class="modal fade" :id="'HistoricoPacotesPacienteModal' + sufixo_modal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Pacotes</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="paciente" class="alert alert-info lead d-flex justify-content-between">
                            <div>
                                {{ paciente.st_nome }}
                            </div>
                            <div v-if="id_atendimento">
                                #{{ id_atendimento }} 
                            </div>
                        </div>

                        <historico-pacotes-paciente 
                            ref="histpacote" 
                            :pode_transferir="!viewonly" 
                            :id_atendimento="id_atendimento" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import HistoricoPacotesPaciente from './HistoricoPacotesPaciente.vue';

export default {
    data() { 
        return { 
            sufixo_modal: '',
        };
    },

    components: { 
        HistoricoPacotesPaciente 
    },

    props: ['paciente', 'id_atendimento', 'viewonly'],
  
    methods: { 
        abrir(id_paciente) { 
            this.$refs.histpacote.abrir(id_paciente);
            $('#HistoricoPacotesPacienteModal' + this.sufixo_modal).modal('show');
        },

        fechar_modal() { 
            $('#HistoricoPacotesPacienteModal' + this.sufixo_modal).modal('hide');
        }
    },

    mounted() { 
        this.sufixo_modal = this.$util.uuidv4();
    }
}
</script>